import React from 'react'
import Button from '../components/Button'
import { Link } from 'react-router-dom'

const MarketingSection2 = () => {
    return (
        <div className='flex items-center text-center xl:text-left justify-between xl:gap-10 gap-5 py-10 xl:py-30 xl:px-35 px-10 flex-col xl:flex-row'>
            <div className='xl:w-[50vw] w-full relative xl:h-[50vh] h-[40vh] overflow-hidden rounded-sm'>
                <div className="flex h-full w-full justify-center items-center ">
                    {/* <Lottie animationData={animationData} loop autoplay style={{ width: "40vw", height: "40vw" }} /> */}
                    <img className='object-cover' src="/new-final-data/marketing/CONWOF.webp" style={{ width: "100%", height: "100%" }} alt="" />
                </div>
                <div className='absolute top-1/2 -translate-y-1/2 xl:left-[10%] md:left-[50%] md:-translate-x-1/2 md:w-full xl:translate-x-0 h-fit xl:w-[40vw] space-y-3 '>
                    <div className="">
                        <h3 className='text-sm text-zinc-300 font-semibold uppercase'>CREATING IMPACT</h3>
                        <h1 className="md:text-4xl text-3xl font-bold mt-2 text-white ">
                            Marketing specialists <br className='hidden xl:block' /> on board
                        </h1>
                    </div>
                    <div className="">
                    </div>

                    <Link to={"/contact"} className='w-fit mx-auto flex xl:inline justify-center items-center'>
                        <Button className={"text-white border-[white_!important]"}>Contact us</Button>
                    </Link>

                </div>

            </div>
            <div className='xl:w-[50vw] w-full relative xl:h-[50vh] h-[40vh] overflow-hidden rounded-sm dark:bg-zinc-900 bg-zinc-100 '>
                <div className='absolute top-1/2 -translate-y-1/2 xl:left-[10%] md:left-[50%] md:-translate-x-1/2 md:w-full xl:translate-x-0 h-fit xl:w-[40vw] space-y-3'>
                    <div className="">
                        <h3 className='text-sm dark:text-zinc-300 text-zinc-400 font-semibold uppercase'>Don’t just compete. Dominate</h3>
                        <h1 className="md:text-4xl text-3xl font-bold mt-2 ">
                            Reaching your <br className='hidden xl:block' /> audience’s hearts
                        </h1>
                    </div>
                    <div className="">
                    </div>

                    <Link to={"/contact"} className='w-fit mx-auto flex xl:inline justify-center items-center'>
                        <Button>Contact us</Button>
                    </Link>
                </div>
            </div>

        </div>
    )
}

export default MarketingSection2